/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/json/common/jsonWorker.nls.ru", {
	"vs/base/common/http": [
		"Bad request. The request cannot be fulfilled due to bad syntax.",
		"Unauthorized. The server is refusing to respond.",
		"Forbidden. The server is refusing to respond.",
		"Not Found. The requested location could not be found.",
		"Method not allowed. A request was made using a request method not supported by that location.",
		"Not Acceptable. The server can only generate a response that is not accepted by the client.",
		"Proxy Authentication Required. The client must first authenticate itself with the proxy.",
		"Request Timeout. The server timed out waiting for the request.",
		"Conflict. The request could not be completed because of a conflict in the request.",
		"Gone. The requested page is no longer available.",
		"Length Required. The \"Content-Length\" is not defined.",
		"Precondition Failed. The precondition given in the request evaluated to false by the server.",
		"Request Entity Too Large. The server will not accept the request, because the request entity is too large.",
		"Request-URI Too Long. The server will not accept the request, because the URL is too long.",
		"Unsupported Media Type. The server will not accept the request, because the media type is not supported.",
		"Internal Server Error.",
		"Not Implemented. The server either does not recognize the request method, or it lacks the ability to fulfill the request.",
		"Service Unavailable. The server is currently unavailable (overloaded or down).",
		"HTTP status code {0}",
	],
	"vs/languages/json/common/contributions/bowerJSONContribution": [
		"Bower.json по умолчанию",
		"Сбой запроса в репозиторий браузера: {0}",
		"Сбой запроса в репозиторий браузера: {0}",
		"{0}",
	],
	"vs/languages/json/common/contributions/globPatternContribution": [
		"Файлы по расширению",
		"Сопоставление всех файлов с определенным расширением",
		"Файлы с несколькими расширениями",
		"Сопоставление всех файлов с любым из расширений файлов",
		"Файлы с элементами того же уровня по имени",
		"Сопоставление файлов с одноранговыми элементами с тем же именем, но разными расширениями",
		"Папка по имени (верхний уровень)",
		"Сопоставление папки верхнего уровня с определенным именем",
		"Папки с несколькими именами (верхний уровень)",
		"Сопоставление нескольких папок верхнего уровня",
		"Папка по имени (любое расположение)",
		"Сопоставление папки с определенным именем в любом расположении",
		"True",
		"Включение шаблона",
		"False",
		"Отключение шаблона",
		"Файлы с элементами того же уровня по имени",
		"Сопоставление файлов с одноранговыми элементами с тем же именем, но разными расширениями",
	],
	"vs/languages/json/common/contributions/packageJSONContribution": [
		"Файл package.json по умолчанию",
		"Сбой запроса в репозиторий NPM: {0}",
		"Сбой запроса в репозиторий NPM: {0}",
		"Последняя версия пакета, существующая на данный момент",
		"Сопоставление последней основной версии (1.x.x)",
		"Сопоставление последней дополнительной версии (1.2.x)",
		"{0}",
		"Последняя версия: {0}",
	],
	"vs/languages/json/common/contributions/projectJSONContribution": [
		"Project.json по умолчанию",
		"Сбой запроса в репозиторий NuGet: {0}",
		"Сбой запроса в репозиторий NuGet: {0}",
		"Последняя версия пакета, существующая на данный момент",
		"{0}",
		"Последняя версия: {0}",
	],
	"vs/languages/json/common/jsonIntellisense": [
		"Значение по умолчанию",
	],
	"vs/languages/json/common/jsonSchemaService": [
		"Unable to load schema from \'{0}\': No content.",
		"Unable to parse content from \'{0}\': {1}.",
		"Не удается загрузить схему из \"{0}\": {1}.",
		"$ref \'{0}\' in {1} can not be resolved.",
		"Problems loading reference \'{0}\': {1}",
	],
	"vs/languages/json/common/parser/jsonParser": [
		"Неверный тип. Ожидаемый тип - один из {0}",
		"Неверный тип. Ожидаемый тип: \"{0}\"",
		"Соответствует неразрешенной схеме.",
		"Соответствует нескольким схемам, хотя достаточно, чтобы проверку прошла только одна.",
		"Значение не является допустимым. Допустимые значения: {0}",
		"Согласно схеме, в массиве слишком много элементов. Ожидаемое количество - не более {0}",
		"В массиве слишком мало элементов. Ожидаемое количество - не менее {0}",
		"В массиве слишком много элементов. Ожидаемое количество - не более {0}",
		"Массив дублирующихся единиц",
		"Значение не делится на {0}",
		"Значение ниже эксклюзивного минимума {0}",
		"Значение меньше минимума, {0}",
		"Значение превышает эксклюзивный максимум {0}",
		"Значение превышает максимум, {0}",
		"Строка короче минимальной длины",
		"Строка короче максимальной длины",
		"Строка не соответствует шаблону \"{0}\"",
		"Отсутствующее свойство \"{0}\"",
		"Свойство {0} запрещено",
		"У объекта больше свойств, чем предельно допустимо ({0})",
		"Объект имеет меньше свойств, чем требуется ({0})",
		"В объекте отсутствует свойство {0}, требуемое свойством {1}",
		"Недопустимая последовательность Юникода в строке",
		"Недопустимый escape-символ в строке",
		"Непредвиденное окончание числа",
		"Непредвиденное окончание комментария",
		"Непредвиденное окончание строки",
		"Ожидаемое значение",
		"Ожидается запятая или закрывающая скобка.",
		"Ключи свойств должны быть заключены в двойные кавычки",
		"Дублирующийся ключ объекта",
		"Ожидается двоеточие",
		"Ожидаемое значение",
		"Ожидалось свойство",
		"Ожидается запятая или закрывающая фигурная скобка.",
		"Недопустимый числовой формат",
		"Недопустимый числовой формат",
		"Ожидается JSON-объект, массив или литерал",
		"Ожидается конец файла",
	]
});